<script lang="ts">
	import { format } from 'svelte-i18n';
	import { fade } from 'svelte/transition';
	import { createEventDispatcher } from 'svelte';
	import { hapticFeedback } from 'src/services/native_container_requests_ios';
	import { os } from 'src/stores/session/native-bridge';
	import { TemperatureWheel, ButtonGroup, Button } from '@Shelly/shelly-design-system';
	import { TempButtonsTypes } from 'src/helpers/enums';

	export let value;
	export let range = [2700, 6500];
	export let disabled = false;

	// const valueRange = devices_config[device.type]?.modes['white']?.color_temp;

	let activeTempButton = '';

	let tempButtonsValues = {
		[TempButtonsTypes.WARM]: range[0],
		[TempButtonsTypes.WHITE]: (range[0] + range[1]) / 2,
		[TempButtonsTypes.COLD]: range[1],
	};

	const dispatch = createEventDispatcher();

	const onSelectTemp = async (newTemp) => {
		value = newTemp;
		dispatch('change', {
			mode: 'temp',
			value: newTemp,
		});
	};

	const onClickButtonInGroup = (
		type: TempButtonsTypes.WARM | TempButtonsTypes.WHITE | TempButtonsTypes.COLD,
	) => {
		activeTempButton = type;
		onSelectTemp(tempButtonsValues[type]);
	};

	const a11yProps = {
		tempWheelAriaLabel: $format('label_temperature', { default: 'Temperature' }),
		thumbAriaLabel: $format('label_temperature_thumb', { default: 'Temperature thumb' }),
		incrementBtnAriaLabel: $format('button_increase_temperature', {
			default: 'Increase temperature',
		}),
		decrementBtnAriaLabel: $format('button_decrease_temperature', {
			default: 'Decrease temperature',
		}),
		spinnerAriaLabel: $format('label_spinner', { default: 'Spinner' }),
	};
</script>

<div in:fade={{ duration: 300 }}>
	<TemperatureWheel
		class="mb-s"
		{a11yProps}
		{value}
		min={range[0]}
		max={range[1]}
		{disabled}
		on:move={() => {
			if ($os === 'IOS') {
				hapticFeedback('selection');
			}
		}}
		on:value_change={(e) => onSelectTemp(e.detail.value)}
	/>

	<div class="d-flex justify-content-center width-full">
		<ButtonGroup
			id="buttongroup-kp7secf"
			aria-label={$format('label_quick_select_temperature', {
				default: 'Quick select temperature',
			})}
		>
			<Button
				{disabled}
				class={activeTempButton === TempButtonsTypes.WARM && 'active'}
				size="m"
				variant="custom"
				customSettings={{
					background: 'var(--color-warning)',
				}}
				on:click={() => onClickButtonInGroup(TempButtonsTypes.WARM)}
				>{$format('button_warm', { default: 'Warm' })}</Button
			>
			<Button
				{disabled}
				class={activeTempButton === TempButtonsTypes.WHITE && 'active'}
				size="m"
				variant="custom"
				on:click={() => onClickButtonInGroup(TempButtonsTypes.WHITE)}
				>{$format('button_white', { default: 'White' })}</Button
			>

			<Button
				{disabled}
				class={activeTempButton === TempButtonsTypes.COLD && 'active'}
				size="m"
				variant="custom"
				customSettings={{
					background: 'var(--color-secondary)',
				}}
				on:click={() => onClickButtonInGroup(TempButtonsTypes.COLD)}
				>{$format('button_cold', { default: 'cold' })}</Button
			>
		</ButtonGroup>
	</div>
</div>
